import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';

import { environment } from '@environments/environment';
import { AuthService } from '@shared/services/auth.service';
import { StateManagerProjectService } from '@state-manager';
import {
  BIG_MODEL_REQUEST_DELAY,
  DEFAULT_NUMBER_OF_ATTEMPTS,
  MODEL_REQUEST_DELAY,
} from '@viewer/services/request-delay.data';

@Injectable()
export class MRIEditerResolver  {
  constructor(
    private _stateManagerProjectService: StateManagerProjectService,
    private _authService: AuthService
  ) {}

  async resolve(route: ActivatedRouteSnapshot): Promise<void> {
    const caseId = route.paramMap.get('id') ?? 'caseId';
    this._stateManagerProjectService.caseId = caseId;
    this._stateManagerProjectService.requestDelayData = {
      modelRequestDelay: await this._getSsmParametersWrapper(
        environment.ssmParams.MODEL_REQUEST_DELAY,
        MODEL_REQUEST_DELAY
      ),
      bigModelRequestDelay: await this._getSsmParametersWrapper(
        environment.ssmParams.BIG_MODEL_REQUEST_DELAY,
        BIG_MODEL_REQUEST_DELAY
      ),
      defaultNumberOfAttempts: await this._getSsmParametersWrapper(
        environment.ssmParams.DEFAULT_NUMBER_OF_ATTEMPTS,
        DEFAULT_NUMBER_OF_ATTEMPTS
      ),
    };
  }

  private async _getSsmParametersWrapper(
    paramKey: string,
    defaultValue: number
  ): Promise<number> {
    try {
      return parseInt(
        (await this._authService.getSsmParameters(paramKey)).Parameter.Value
      );
    } catch (err) {
      console.error(`Failed to get parameter: '${paramKey}'\nError: ${err}`);
      return defaultValue;
    }
  }
}
